import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info',
  templateUrl: './tooltip-info.component.html',
  styleUrls: ['./tooltip-info.component.scss']
})
export class TooltipInfoComponent {}
